import { useCallback } from "react";

import { Link, Switch } from "@shapr3d/frontend-lib";
import classNames from "classnames";

import { privacyPolicyUrl, termsOfUseUrl } from "../../../config";
import useUrlHelper from "../../../hooks/urlHelper";
import useTranslation from "../../../hooks/useTranslation";

import style from "./Disclaimer.module.css";

export interface DisclaimerProps {
  className?: string;
  areTermsAccepted: boolean;
  handleToggleTermsAccepted: () => void;
  tabIndex?: number;
  disabled?: boolean;
}

const Disclaimer = ({
  className,
  areTermsAccepted,
  handleToggleTermsAccepted,
  tabIndex,
  disabled = false,
}: DisclaimerProps) => {
  const { isInApp, isFromApp } = useUrlHelper();

  const setHideHeaderParams = useCallback(
    (originalUrl: string) => {
      const url = new URL(originalUrl);
      const queryParams = new URLSearchParams();
      if (isInApp || isFromApp) {
        queryParams.set("hide_header", "true");
      }
      url.search = queryParams.toString();
      return url.toString();
    },
    [isInApp, isFromApp]
  );

  const { t, m } = useTranslation();
  return (
    <div className={classNames(style.disclaimerContainer, className)}>
      <Switch
        checked={areTermsAccepted}
        onChange={handleToggleTermsAccepted}
        tabIndex={tabIndex}
        disabled={disabled}
      />
      <div className={style.disclaimer}>
        {t(m.SignUp.AgreeTerms, {
          termsOfUse: (
            <Link
              href={setHideHeaderParams(termsOfUseUrl)}
              rel="noreferrer noopener"
              target="_blank"
              tabIndex={-1}
            >
              {t(m.General.TermsOfUse)}
            </Link>
          ),
          privacyPolicy: (
            <Link
              href={setHideHeaderParams(privacyPolicyUrl)}
              rel="noreferrer noopener"
              target="_blank"
              tabIndex={-1}
            >
              {t(m.General.PrivacyPolicy)}
            </Link>
          ),
        })}
      </div>
    </div>
  );
};

export default Disclaimer;
